import { enumToStaticValue } from '@/utils'
import { ItemType } from './itemType'

export default enumToStaticValue(ItemType, 'item-type')
